var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.580566 1.99756C0.580566 1.58335 0.916353 1.24756 1.33057 1.24756H14.6695C15.0837 1.24756 15.4195 1.58335 15.4195 1.99756C15.4195 2.41177 15.0837 2.74756 14.6695 2.74756H1.33057C0.916353 2.74756 0.580566 2.41177 0.580566 1.99756Z",
    className: "icon-fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 4.24878C8.41421 4.24878 8.75 4.58457 8.75 4.99878V8.66697C8.75 9.08119 8.41421 9.41697 8 9.41697C7.58579 9.41697 7.25 9.08119 7.25 8.66697V4.99878C7.25 4.58457 7.58579 4.24878 8 4.24878Z",
    className: "icon-fill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33203 6.69458C5.74624 6.69458 6.08203 7.03037 6.08203 7.44458V8.66709C6.08203 9.0813 5.74624 9.41709 5.33203 9.41709C4.91782 9.41709 4.58203 9.0813 4.58203 8.66709V7.44458C4.58203 7.03037 4.91782 6.69458 5.33203 6.69458Z",
    className: "icon-fill"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.668 5.47144C11.0822 5.47144 11.418 5.80722 11.418 6.22144V8.66712C11.418 9.08133 11.0822 9.41712 10.668 9.41712C10.2538 9.41712 9.91797 9.08133 9.91797 8.66712V6.22144C9.91797 5.80722 10.2538 5.47144 10.668 5.47144Z",
    className: "icon-fill"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.99707 1.24756C2.41128 1.24756 2.74707 1.58335 2.74707 1.99756V9.92219C2.74707 10.2462 3.03955 10.5848 3.4977 10.5848H12.5014C12.9596 10.5848 13.2521 10.2462 13.2521 9.92219V1.99756C13.2521 1.58335 13.5879 1.24756 14.0021 1.24756C14.4163 1.24756 14.7521 1.58335 14.7521 1.99756V9.92219C14.7521 11.1588 13.7013 12.0848 12.5014 12.0848H3.4977C2.29781 12.0848 1.24707 11.1588 1.24707 9.92219V1.99756C1.24707 1.58335 1.58286 1.24756 1.99707 1.24756Z",
    className: "icon-fill"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33175 10.6641C8.70223 10.4788 9.15273 10.629 9.33798 10.9995L10.6719 13.6672C10.8571 14.0377 10.7069 14.4882 10.3365 14.6735C9.96597 14.8587 9.51547 14.7086 9.33022 14.3381L7.99634 11.6703C7.81109 11.2998 7.96126 10.8493 8.33175 10.6641Z",
    className: "icon-fill"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66849 10.6641C8.03897 10.8493 8.18914 11.2998 8.0039 11.6703L6.67001 14.3381C6.48477 14.7086 6.03426 14.8587 5.66378 14.6735C5.29329 14.4882 5.14313 14.0377 5.32837 13.6672L6.66226 10.9995C6.8475 10.629 7.298 10.4788 7.66849 10.6641Z",
    className: "icon-fill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDashboard);
export default __webpack_public_path__ + "static/media/icon-dashboard.12a7fd818573ab8cdbe5aa6492123622.svg";
export { ForwardRef as ReactComponent };